import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import IssuesColumn from '../components/IssuesColumn'
import { LoadingSpinner } from '../../common'

const ToDoContainer = ({
  loading,
  loaded,
  numResults,
  docs,
}) => {
  return (
    <>
      {loading && <LoadingSpinner />}
      {loaded && <IssuesColumn title="To do" numResults={numResults} docs={docs} />}
    </>
  )
}

ToDoContainer.propTypes = {
  loading: PropTypes.bool.isRequired,
  loaded: PropTypes.bool.isRequired,
  numResults: PropTypes.number.isRequired,
  docs: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
}

const mapStateToProps = ({
  issues: { toDo: { loading, loaded, data: { numResults, docs } } },
}) => ({
  loading,
  loaded,
  numResults,
  docs,
})

export default connect(mapStateToProps)(ToDoContainer)
